import { useMutation } from '@tanstack/react-query';

import ExternalService from '../services/ExternalService/ExternalApiService';

import { normalizeIDPResponse } from './use-getidpurl';

/**
 * Calls the generate-link endpoint to create a verification URL for ID proofing.
 *
 * @async
 * @function generateIDPLink
 */
const generateIDPLink = async ({ key }: { key: string }) =>
  normalizeIDPResponse(await ExternalService.generateIDPLink(key));

/**
 * Custom hook to generate an IDP verification link via the generate-link API.
 *
 * @function useGenerateIDPLink
 */
const useGenerateIDPLink = () =>
  useMutation({
    mutationFn: (payload: { key: string }) => generateIDPLink(payload),
  });

export default useGenerateIDPLink;
